module.exports = __webpack_public_path__ + "img/H2.4f952128.png";